import { Outlet, createRootRoute, createRoute } from "@tanstack/react-router";
import AppLayout from "./layout/app-layout/app-layout";
import AppLayout1 from "./layout/app-layout/app-layout1";
import AppLayout2 from "./layout/app-layout/app-layout2";
import { unauthorisedErrorRoute } from "./errors/401";
import { forbiddenErrorRoute } from "./errors/403";
import { notFoundErrorRoute } from "./errors/404";
import { generalErrorRoute } from "./errors/500";
import { maintenanceErrorRoute } from "./errors/503";
import NotFoundError from "@/components/errors/not-found-error";
import GeneralError from "@/components/errors/general-error";
import { requireAuth } from "@/Guard/require-auth";
import { requireGuest } from "@/Guard/require-guest";
import { signInRoute } from "./apps/auth.routes";
import { NavigationProgress } from "@/components/ui/navigation-progress";
import {
  creactPracticeTestRoute,
  dashboardRoute,
  // dashboardRoute,
  mockTestResultRoute,
  mockTestRoute,
  myClassDetailRoute,
  myClassRoute,
} from "./apps/apps.routes";
import AuthProvider from "@/providers/auth.provider";
import CenteredLayout from "./layout/centered-layout.tsx/centered-layout";
// import { TanStackRouterDevtools } from "@tanstack/router-devtools";

function RootComponent() {
  return (
    <AuthProvider>
      <NavigationProgress />
      <Outlet />
      {/* <TanStackRouterDevtools position="bottom-right" /> */}
    </AuthProvider>
  );
}
export const rootRoute = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
});
export const errorLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "error-layout-route",
  component: () => <Outlet />,
});
export const authLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "auth-layout-route",
  component: () => <Outlet />,
  beforeLoad: () => requireGuest(),
});
export const layoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "layout-route",
  component: AppLayout,
  beforeLoad: (ctx) => requireAuth(ctx.location),
});
export const layout1Route = createRoute({
  getParentRoute: () => rootRoute,
  id: "layout1-route",
  component: AppLayout1,
  beforeLoad: (ctx) => requireAuth(ctx.location),
  notFoundComponent: NotFoundError,
});
export const layout2Route = createRoute({
  getParentRoute: () => rootRoute,
  id: "layout2-route",
  component: AppLayout2,
  beforeLoad: (ctx) => requireAuth(ctx.location),
  notFoundComponent: NotFoundError,
});
export const centeredRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "centered-route",
  component: CenteredLayout,
  beforeLoad: (ctx) => requireAuth(ctx.location),
  notFoundComponent: NotFoundError,
});

export const routeTree = rootRoute.addChildren([
  // layoutRoute.addChildren([dashboardRoute]),
  layout1Route.addChildren([dashboardRoute, myClassRoute]),
  layout2Route.addChildren([myClassDetailRoute]),
  centeredRoute.addChildren([
    mockTestRoute,
    mockTestResultRoute,
    creactPracticeTestRoute,
  ]),
  authLayoutRoute.addChildren([signInRoute]),
  errorLayoutRoute.addChildren([
    unauthorisedErrorRoute,
    forbiddenErrorRoute,
    notFoundErrorRoute,
    generalErrorRoute,
    maintenanceErrorRoute,
  ]),
]);
